
    export default {
      path: `/home/runner/work/fase2-website/fase2-website/src/components/layout/hex-button.kpa`,
      template: `<div class="hex-button hex-{{color}}">
        <span class="hex-link hex-green">
            <img class="hex-img" src="/images/hexagon-green-big.png" alt="{{text}}">
            <span>{{text}}</span>
        </span>

        <span class="hex-link hex-gray">
            <img class="hex-img" src="/images/hexagon-gray-big.png" alt="{{text}}">
            <span>{{text}}</span>
        </span>
    </div>`,
      style: `hex-button .hex-button {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
}
hex-button .hex-button .hex-link {
  display: none;
  position: relative;
  width: 400px;
  height: 400px;
}
hex-button .hex-button .hex-link img.hex-img {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
  height: auto;
}
hex-button .hex-button .hex-link span {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-family: "Lato", serif;
  font-weight: 700;
  font-style: normal;
  font-size: 1.8rem;
  text-align: center;
}
hex-button .hex-button.hex-green .hex-link.hex-green {
  display: block;
}
hex-button .hex-button.hex-green .hex-link.hex-green span {
  color: #2c4143;
}
hex-button .hex-button.hex-gray .hex-link.hex-gray {
  display: block;
}
hex-button .hex-button.hex-gray .hex-link.hex-gray span {
  color: #64c16c;
}`,
      script: `(async () => { "use strict";
return {
    data: {},
    props: {
        text: {
            type: String,
            default: "",
        },
        color: {
            type: String,
            default: "gray",
        },
    },
    events: [
        ['click', '.hex-button a', function (event) {
                event.preventDefault();
                router.navigate(event.target.closest('a').getAttribute('href'));
            }],
    ],
};
 })()`
    };
  